import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/turath2/turath-websites/turath-website-learn/ar-prod/features/course/components/path-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/turath2/turath-websites/turath-website-learn/ar-prod/features/course/components/path-info-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/turath2/turath-websites/turath-website-learn/ar-prod/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
